import type { ComboboxItem } from '@/components'
import { Combobox } from '@/components'
import type { ExportPeriod } from '@/modules/exports/components/export-form'
import {
  ExportCard,
  ExportField,
  ExportMethodField,
  ExportPeriodField,
} from '@/modules/exports/components/export-form'
import { useTranslate } from '@ur-solutions/react-hooks'
import { endOfDay, startOfDay } from 'date-fns'
import type { DriverGradesExportForm } from '../../hooks'
import { useExportDriverGradesForm } from '../../hooks'

type Source = DriverGradesExportForm['sources'][number]
type SortBy = DriverGradesExportForm['sortBy']

const SOURCE_ITEMS: ComboboxItem<Source>[] = [
  { label: 'Volvo', value: 'VOLVO' },
  { label: 'Scania', value: 'SCANIA' },
]

export const ExportDriverGradesCard: React.FC = () => {
  const translations = useTranslate({
    title: 'driver-grades.export-driver-grades',
    source: 'common.source',
    allSources: 'common.all',
    sortBy: 'common.sort-by',
    sortName: 'common.name',
    sortAvgDesc: 'driver-grades.sort-avg-desc',
  })

  const { loading, form, submit, updateForm, handleExport, handler } =
    useExportDriverGradesForm()

  const sortItems: ComboboxItem<SortBy>[] = [
    { label: translations.sortName, value: 'NAME' },
    { label: translations.sortAvgDesc, value: 'AVG_DESC' },
  ]

  function handlePeriodChange(value: Partial<ExportPeriod>) {
    updateForm({
      ...value,
      ...(value.dateStart && { dateStart: startOfDay(value.dateStart) }),
      ...(value.dateEnd && { dateEnd: endOfDay(value.dateEnd) }),
    })
  }

  return (
    <ExportCard
      title={translations.title}
      loading={loading}
      onSubmit={submit(handleExport)}
    >
      <ExportPeriodField value={form} onChange={handlePeriodChange} />

      <ExportMethodField
        value={form.exportOption}
        onChange={handler('exportOption')}
      />

      <ExportField label={translations.source}>
        <Combobox<Source | ''>
          mode="single"
          noSearch
          clearable
          placeholder={translations.allSources}
          value={form.sources[0] ?? ''}
          items={SOURCE_ITEMS}
          onChange={value => updateForm({ sources: value ? [value] : [] })}
        />
      </ExportField>

      <ExportField label={translations.sortBy}>
        <Combobox
          mode="single"
          noSearch
          value={form.sortBy}
          items={sortItems}
          onChange={value => {
            if (value) updateForm({ sortBy: value })
          }}
        />
      </ExportField>
    </ExportCard>
  )
}
